<div class="panel panel-default">
    <div class="panel-heading">
        <div class="panel-title">Recent Notes</div>
    </div>
    <div class="panel-body">
        <div *ngIf="!isLoaded" class="whirl standard spinnermargin"></div>
        <ng-template [ngIf]="isLoaded">
            <div *ngIf="notes.length > 0" class="table-responsive">
                <table class="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let n of notes">
                            <td class="text-nowrap">{{ n.timestamp_formatted }}</td>
                            <td>
                                <span class="badge badge-secondary">{{ n.type }}</span>
                            </td>
                            <td>{{ truncate(n.text, 120) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="notes.length === 0" class="text-center text-muted py-lg">
                No recent notes.
            </div>
        </ng-template>
    </div>
</div>